import {
  borderRadius,
  Button,
  customScrollMinimal,
  Drawer,
  Modal,
  typographyV2,
} from '@toggle/design-system';
import styled from 'styled-components';

import { ChatInputComposer } from '~/components/chat';

export const Title = styled.div`
  ${typographyV2.titleMd}
  color: var(--text-default);
  margin-bottom: 8px;
`;

export const Root = styled.div`
  width: 100%;
  height: auto;
  border: 1px solid var(--border-soft);
  ${borderRadius.r2}
`;

export const StyledDrawer = styled(Drawer)`
  ${Drawer.Styled.Body} {
    overflow: hidden;
  }

  ${Drawer.Styled.Container} {
    width: 90vw;
  }
`;

export const DrawerSectionWrapper = styled.div`
  display: flex;
  overflow: hidden;
  height: 100%;
`;

export const CitationsHeaderTitle = styled.h2`
  ${typographyV2.titleMd}
`;

export const DrawerSection = styled.div`
  width: 50%;
  height: 100%;
  display: flex;
  flex-direction: column;

  &:first-child {
    padding: 20px;
    border-right: 1px solid var(--border-soft);
    overflow: scroll;
    ${customScrollMinimal};
  }

  &:last-child {
    display: inline-grid;
    padding: 12px;
    height: 100%;
  }
`;

export const DocumentChatButton = styled(Button)`
  position: absolute;
  right: 24px;
`;

export const DocumentChatModal = styled(Modal)`
  ${Modal.Styled.ModalContainer} {
    width: 674px;
    border-radius: 8px;
    border: 1px solid var(--border-soft);
    background: var(--background-soft);
    padding-bottom: 0;
  }

  ${Modal.Styled.Header} {
    padding: 6px 6px 20px 20px;

    ${Modal.Styled.TextContainer} {
      margin: 18px 0 0 0;
    }
  }

  ${Modal.Styled.Title} {
    margin-bottom: 24px;
  }

  ${Modal.Styled.Description} {
    margin-top: 12px;
  }

  ${ChatInputComposer.Styled.Form} {
    width: 100%;
  }
`;
